export const fullFieldProps = {
  lg: 12,
  xs: 12,
};

export const defaultFieldProps = {
  lg: 6,
  xs: 12,
};
